<template>
  <div
    class="project-structure-widget-overlay grey darken-4"
    :style="location?
      'height: 100%; top: 0px;'
      :
      'justify-content: space-around; align-items: center;'

      "
    >
    <slot/>
  </div>
</template>
<script>
  export default {
    props: ['location'],
    data: () => ({
    }),
  }
</script>
<style>
  .project-structure-widget-overlay {
    position: absolute;
    width: 100%;
    height: 30%;
    top: 73%;
    z-index: 10;
    padding: 5px;
  }
</style>
